import {
  alpha,
  Autocomplete,
  Box,
  Checkbox,
  Chip,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  Skeleton,
  Stack,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import api from "../../../services/api";
import {
  Close,
  Refresh,
  Timeline,
  WarningAmberRounded,
} from "@mui/icons-material";
import LineChart from "./charts";
import DateFilter from "./dateFilter";
import IconTransform from "../iconsElement";
import { VirtualizedListbox } from "../vitualizationAutoComplete";
import { useMapa } from "../../../contexts/mapaContext";
import { useOutletContext } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import { ReactComponent as EmptyBox } from "../../../assets/easyReport/iconSvg/emptyBox.svg";
import { ptBR } from "@mui/x-data-grid/locales";
import * as dayjs from "dayjs";
const itemsNameToHost = [
  { itemName: "Status PING", multiple: false, unit: "number", method: "max" },
  {
    itemName: "Tempo de resposta PING",
    multiple: false,
    unit: "ms",
    method: "avg",
  },
  { itemName: "Perda de PING", multiple: false, unit: "%", method: "max" },
  {
    itemName: "Respostas SNMP",
    multiple: false,
    unit: "number",
    method: "max",
  },
];
// const healthItemsNameToHost = [
//   { itemName: "Memória Utilizada em Porcentagem", multiple: false, unit: "%" },
//   { itemName: "Temperatura da CPU", multiple: false, unit: "%" },
//   { itemName: "CPU Utilizada%", multiple: true, unit: "%" },
//   { itemName: "Uso de CPU%", multiple: true, unit: "%" },
//   { itemName: "Utilização da CPU%", multiple: true, unit: "%" },
//   { itemName: "Velocidade da FAN%em Porcentagem", multiple: true, unit: "%" },
// ];

export default function ModalHistoryItem(params) {
  const {
    openHistoryModal,
    setOpenHistoryModal,
    elementSelected,
    enlaceSelected,
    iconsElements,
    host,
  } = params;
  const { mapId, connectionsDataMap } = useMapa();
  const { configLayer } = useOutletContext();
  const isPotencia = configLayer?.[mapId] === "potencia";

  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(false);
  const [result, setResult] = useState({});
  const [requestedItems, setRequestedItems] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [hostByElement, setHostByElement] = useState(host);
  const [valueTab, setValueTab] = useState(1);
  const [filtersState, setFilterState] = useState({
    timeStart: new Date(new Date().setHours(new Date().getHours() - 24)),
    timeEnd: new Date(),
    option: null,
  });
  const [pageSize, setPageSize] = useState(10);
  const [isRefresh, setIsRefresh] = useState(false);
  const dateFilterRef = useRef();
  const abortControllerRef = useRef(null);
  const prevElementRef = useRef(null);
  const prevEnlaceRef = useRef(null);

  const theme = useTheme();
  const styles = {
    modal: { display: "flex", justifyContent: "center", alignItems: "center" },
    paper: {
      maxWidth: "1084px",
      width: "100%",
      maxHeight: "90vh",
      minHeight: "632px",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "flex-start",
    },
    subtitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: "text.primary",
    },
    dialogTitle: {
      width: "100%",
    },
    dialogActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      gap: 0,
      padding: 0,
      width: "100%",
    },
    dialogContent: {
      width: "100%",
      height: "100%",
      maxHeight: 500,
      display: "flex",
      flexDirection: "column",
      padding: 2,
      gap: 1.5,
    },
    boxRowFields: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "160px",
      gap: 1,
    },
    boxInvalidItem: {
      display: "flex",
      flexDirection: "column",
      alignItems: "start",
      justifyContent: "center",
      width: "100%",
      height: "160px",
      gap: 1,
      p: 2,
      borderRadius: "6px",
      backgroundColor: theme.palette.background.cardStatus,
    },
    boxHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "flex-end",
      mb: 1,
      p: 2,
    },
    boxTitle: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "start",
      alignItems: "center",
      color: "primary.main",
      width: "100%",
      gap: 1,
    },
    tabs: {
      width: "100%",
      minHeight: "20px",
      "& button": {
        color: theme.palette.text.disabled,
        textTransform: "none",
        minHeight: "20px",
        Height: "100%",
        borderRadius: "5px",
        paddingX: "10px",
      },
      "& .MuiTab-icon": { marginRight: "2px" },
      "& button.Mui-selected": {
        backgroundColor: theme.palette.background.paper,
      },
      "& .MuiTabs-indicator": {
        backgroundColor: "transparent",
        border: "none",
      },
    },
    card: {
      borderRadius: "5px",
      border: "none",
      "&::before": {
        display: "none",
      },
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "start",
      width: "100%",
      maxWidth: 260,
    },
    text: {
      fontSize: "0.875rem",
      color: theme.palette.color.text,
    },
    stackContainer: {
      display: "flex",
      flexDirection: { xs: "column", md: "row" },
      gap: 2,
      justifyContent: "space-between",
      alignItems: { xs: "start", md: "center" },
    },
    stackFilters: {
      display: "flex",
      flexDirection: "row",
      gap: 2,
      justifyContent: "start",
      alignItems: { xs: "start", md: "center" },
    },
    stackOption: {
      flexDirection: "row",
      width: "100%",
      p: "5px",
      alignItems: "center",
    },
    textoLimitado: {
      display: "-webkit-box",
      WebkitLineClamp: 2, // Limita o texto a 2 linhas
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    textAdorment: {
      ml: "-5px",
      fontSize: "12px",
      fontWeight: 800,
      color: theme.palette.color.bgIcon,
    },
    skeleton: {
      width: "100%",
      height: "58px",
      borderRadius: "6px",
      backgroundColor: theme.palette.background.paperLinkedMaps,
    },
    dataGrid: {
      width: "100%",
      height: "100%",
      minHeight: 100,
      fontSize: 12,
      borderRadius: "7px",
      border: 0,
      backgroundColor: theme.palette.background.cardStatus,
      "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
        outline: "none !important",
      },
      ".MuiDataGrid-cell": {
        display: "flex",
        alignItems: "center",
        borderColor: theme.palette.background.tab,
      },
      "& .MuiDataGrid-scrollbar--vertical": {
        display: "none",
      },
      "& .MuiDataGrid-filler": {
        display: "none",
      },
      "& .MuiDataGrid-scrollbarFiller--borderTop": {
        display: "none",
      },
      "& .MuiDataGrid-scrollbarFiller--header": {
        backgroundColor: theme.palette.background.cardStatus,
        borderTop: `1px solid ${theme.palette.background.tab}`,
      },
      "& .MuiDataGrid-columnHeaderTitle": {
        color: "text.primary",
      },
      "& .MuiDataGrid-footerContainer": {
        backgroundColor: "transparent",
        border: 0,
        borderTop: `1px solid ${theme.palette.background.tab}`,
        height: "45px",
      },
      "& .MuiDataGrid-columnHeader": {
        backgroundColor: theme.palette.background.cardStatus,
        border: 0,
        borderTop: `1px solid ${theme.palette.background.tab}`,
      },
      "& .MuiDataGrid-topContainer": {
        border: 0,
        backgroundColor: theme.palette.background.cardStatus,
      },
      "& .MuiDataGrid-row--borderBottom": {
        border: 0,
      },
      "& .MuiDataGrid-columnHeaders": {
        border: 0,
        height: "55px",
        backgroundColor: theme.palette.background.cardStatus,
      },

      "& .even-row": {
        backgroundColor: theme.palette.background.paperSelectedMaps,
      },
      "& .odd-row": {
        backgroundColor: theme.palette.background.cardStatus,
      },
      "& .blink-row": {
        animation: "bg-pulse 1.4s ease-in-out infinite",
      },
      "@keyframes bg-pulse": {
        "50%": {
          backgroundColor: alpha(theme.palette.primary.main, 0.2),
        },
        "100%": {
          backgroundColor: alpha(theme.palette.primary.dark, 0.2),
        },
      },
    },
    boxNoRowsOverlay: {
      p: 2,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      backgroundColor: theme.palette.background.cardStatus,
    },
    iconUserNotFound: {
      width: "140px",
      height: "140px",
      fill: theme.palette.text.disabled,
    },
    boxRenderCell: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      alignItems: "center",
      gap: 1,
    },
    typography: {
      fontSize: "1rem",
      color: theme.palette.text.secondary,
    },
    chip: {
      fontWeight: 500,
      padding: "0px 8px",
      height: "28px",
      maxWidth: "150px",
    },
  };
  const connectionData = useMemo(
    () => connectionsDataMap?.get(enlaceSelected?.id),
    [connectionsDataMap, enlaceSelected?.id],
  );
  const hostsElement = useMemo(
    () =>
      elementSelected?.mapRef?.Element?.flatMap(
        (e) => e?.elementConfig?.config?.hosts,
      ) || [],
    [elementSelected],
  );
  useEffect(() => {
    if (host) {
      setHostByElement(host);
    }
  }, [host]);

  useEffect(() => {
    if (!openHistoryModal) return;
    if (!elementSelected && !enlaceSelected && !connectionData) return;

    async function fetchData() {
      setIsSubmit(true);

      const isNewTarget =
        prevElementRef.current !== elementSelected ||
        prevEnlaceRef.current !== enlaceSelected;
      prevElementRef.current = elementSelected;
      prevEnlaceRef.current = enlaceSelected;

      if (isNewTarget) {
        setInitialLoading(true);
        setResult({});
        setAlerts([]);
      } else {
        setLoading(true);
      }
      abortControllerRef.current?.abort();
      const controller = new AbortController();
      const signal = controller.signal;

      abortControllerRef.current = controller;
      try {
        const hostId = resolveHostId(
          hostByElement,
          elementSelected,
          hostsElement,
        );
        if (!hostId) return;

        const itemKeys = resolveItemKeys(
          enlaceSelected,

          itemsNameToHost.flatMap((i) => i.itemName),
        );
        setRequestedItems(Array.isArray(itemKeys) ? itemKeys : []);

        const historyPayload = {
          initialDate: filtersState.timeStart,
          finalDate: filtersState.timeEnd,
          option: filtersState.option,
          hostId,
          itens: itemKeys,
        };

        const eventsPayload = {
          initialDate: filtersState.timeStart,
          finalDate: filtersState.timeEnd,
          option: filtersState.option,
          hostId: [hostId],
          interface: connectionData?.interface,
          excludeInterface: !enlaceSelected,
        };

        const [historyResponse, eventsResponse] = await Promise.all([
          itemKeys
            ? api.post("/easyMaps/modal/history", historyPayload, { signal })
            : Promise.resolve({ data: null }),
          api.post("/easyMaps/modal/events", eventsPayload, { signal }),
        ]);

        if (!signal.aborted) {
          if (historyResponse.data) setResult(historyResponse.data);
          if (eventsResponse.data) setAlerts(eventsResponse.data);
        }
      } catch (error) {
        console.error("Erro:", error);
      } finally {
        if (!signal.aborted) {
          setLoading(false);
          setInitialLoading(false);
        }
        setIsRefresh(false);
      }
    }

    fetchData();
  }, [
    filtersState.timeStart,
    filtersState.timeEnd,
    filtersState.option,
    hostByElement,
    elementSelected,
    enlaceSelected,
    hostsElement,
    connectionData?.interface,
    openHistoryModal,
    isRefresh,
  ]);

  function resolveHostId(hostByElement, elementSelected, hostsElement) {
    if (hostByElement) return hostByElement;
    if (elementSelected?.tipo !== 0) return hostsElement[0]?.hostid;
    return elementSelected?.elementConfig?.config?.hosts?.[0]?.hostid;
  }

  function resolveItemKeys(enlaceSelected, itemsNameToHost) {
    if (!enlaceSelected) return itemsNameToHost;
    //[   ...itemsNameToHost;
    //   ...healthItemsNameToHost.flatMap((i) => i.itemName),
    // ];

    return enlaceSelected.item
      .filter((i) => {
        const itemName = i.itemName.toLowerCase();
        return itemName.includes("potência") || itemName.includes("tráfego");
      })
      .map((i) => i.itemName);
  }

  const handleClose = () => {
    setOpenHistoryModal(false);
    setFilterState({
      timeStart: new Date(new Date().setHours(new Date().getHours() - 24)),
      timeEnd: new Date(),
      option: null,
    });
    setHostByElement(null);
    setIsSubmit(false);
    setValueTab(1);
    prevElementRef.current = null;
    prevEnlaceRef.current = null;
  };

  const isOptionEqualToValue = (option, value) => {
    return option?.hostid === value?.hostid;
  };

  const filteredData =
    elementSelected && !enlaceSelected
      ? /* valueTab === 1 ? */ itemsNameToHost /* : healthItemsNameToHost */
          .reduce((obj, itemConfig) => {
            const pattern = itemConfig.itemName;

            const regex = new RegExp("^" + pattern.replace(/%/g, ".*"), "i");

            const matches = Object.entries(result).filter(([key]) =>
              regex.test(key),
            );

            if (matches.length > 0) {
              obj[pattern] = {
                itemName: pattern,
                unit: itemConfig.unit,
                method: itemConfig.method,
                isMultiple: itemConfig.multiple,
                allData: matches.map(([key, value]) => ({
                  label: key,
                  data: value.data,
                })),
              };
            }
            return obj;
          }, {})
      : (() => {
          const obj = Object.entries(result)
            .sort(([keyA], [keyB]) => {
              const isA = keyA.toLowerCase().startsWith("tráfego");
              const isB = keyB.toLowerCase().startsWith("tráfego");

              if (isA === isB) return keyA.localeCompare(keyB);

              return isA ? -1 : 1;
            })
            .reduce((acc, [key, value]) => {
              acc[key] = {
                itemName: key,
                unit: "",
                method: "",
                isMultiple: false,
                allData: [{ label: key, data: value.data }],
              };
              return acc;
            }, {});

          requestedItems.forEach((itemName) => {
            if (itemName?.includes("$1") && !obj[itemName]) {
              obj[itemName] = {
                itemName,
                unit: "",
                method: "",
                isMultiple: false,
                allData: [],
              };
            }
          });

          return obj;
        })();

  const getSeverityConfig = (severity) => {
    switch (severity) {
      case 1:
        return { label: "Informação", color: theme.palette.info.main };
      case 2:
        return { label: "Alerta", color: theme.palette.warning.main };
      case 3:
        return { label: "Moderado", color: theme.palette.enlaces.p50.main };
      case 4:
        return { label: "Alto impacto", color: theme.palette.error.main };
      case 5:
        return { label: "Desastre", color: theme.palette.error.dark };
      default:
        return { label: "Não classificado", color: theme.palette.grey[500] };
    }
  };
  const columns = [
    {
      field: "alert",
      headerName: "Alerta",
      minWidth: 300,
      flex: 2,
      renderCell: (params) => {
        return (
          <Box sx={styles.boxRenderCell}>
            <Tooltip title={params.value}>
              <Typography fontSize={13}>{params.value}</Typography>
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "severity",
      headerName: "Severidade",
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        const { label, color } = getSeverityConfig(parseInt(params.value));
        return (
          <Box sx={styles.boxRenderCell}>
            <Tooltip title={label}>
              <Chip
                sx={{
                  ...styles.chip,
                  backgroundColor: alpha(color, 0.3),
                  color: color,
                }}
                label={label}
                key={label}
              />
            </Tooltip>
          </Box>
        );
      },
    },
    {
      field: "initialDate",
      headerName: "Horário da ocorrência",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => (
        <Box sx={styles.boxRenderCell}>
          <Typography sx={styles.typography}>
            {params.row.initialDate
              ? dayjs.unix(params.row.initialDate).format("DD/MM/YYYY h:mm:ss")
              : "-"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "recoveryDate",
      headerName: "Horário de recuperação",
      minWidth: 180,
      flex: 1,
      renderCell: (params) => (
        <Box sx={styles.boxRenderCell}>
          <Typography sx={styles.typography}>
            {params.row.recoveryDate
              ? dayjs.unix(params.row.recoveryDate).format("DD/MM/YYYY h:mm:ss")
              : "-"}
          </Typography>
        </Box>
      ),
    },
    {
      field: "duration",
      headerName: "Duração",
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        if (!params.value) return "-";
        const d = dayjs.duration(params.value);

        const formatado = d.format("HH:mm:ss");
        return (
          <Box sx={styles.boxRenderCell}>
            <Typography sx={styles.typography}>{formatado}</Typography>
          </Box>
        );
      },
    },
  ];
  function CustomNoRowsOverlay() {
    return (
      <Box sx={styles.boxNoRowsOverlay}>
        <EmptyBox style={styles.iconUserNotFound} />
        <Typography color="text.disabled">Nenhum alerta encontrado</Typography>
      </Box>
    );
  }

  return (
    <Modal
      open={openHistoryModal}
      onClose={() => handleClose()}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      sx={styles.modal}
    >
      <Paper sx={styles.paper}>
        <DialogTitle sx={styles.dialogTitle} color="primary.main">
          <Box sx={styles.boxHeader}>
            <Box sx={styles.boxTitle}>
              <Stack
                sx={{
                  height: "45px",
                  width: "45px",
                  backgroundColor: alpha(theme.palette.primary.main, 0.2),
                  borderRadius: "5px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Timeline fontSize="medium" sx={{ color: "primary.main" }} />
              </Stack>
              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    minWidth: "260px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  fontWeight={500}
                >
                  {enlaceSelected && connectionData
                    ? connectionData.interface
                    : elementSelected?.titulo}
                </Typography>{" "}
                <Typography
                  sx={{
                    minWidth: "260px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                  fontSize={14}
                  color="text.secondary"
                >
                  Histórico de monitoramento
                </Typography>
              </Stack>
            </Box>
            <IconButton
              aria-label="close"
              onClick={() => {
                handleClose();
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Stack
            sx={{
              ...styles.stackContainer,
              justifyContent: "flex-end",
            }}
          >
            {/* 
            Por enquanto será comentado
            {elementSelected && !enlaceSelected && (
              <Stack
                sx={[
                  styles.card,
                  {
                    p: 0.5,
                    height: "50px",
                    backgroundColor: theme.palette.background.paperLinkedMaps,
                  },
                ]}
              >
                <Tabs
                  variant="fullWidth"
                  value={valueTab}
                  onChange={(e, value) => setValueTab(value)}
                  textColor="primary"
                  indicatorColor="primary"
                  sx={styles.tabs}
                >
                  <Tab
                    icon={valueTab == 1 ? <ListOutlined /> : null}
                    label="Gerais"
                    value={1}
                    sx={styles.text}
                    iconPosition="start"
                  />
                  <Tab
                    icon={valueTab == 2 ? <MonitorHeart /> : null}
                    label="Saúde"
                    value={2}
                    sx={styles.text}
                    iconPosition="start"
                  />
                </Tabs>
              </Stack>
            )} */}
            <Stack
              sx={{
                ...styles.stackFilters,
                flexDirection: { xs: "column", sm: "row" },
                width: { xs: "100%", sm: "auto" },
                gap: 2,
              }}
            >
              {!enlaceSelected &&
                elementSelected &&
                elementSelected.tipo !== 0 && (
                  <Autocomplete
                    disablePortal
                    getOptionLabel={(option) => option?.host || ""}
                    isOptionEqualToValue={isOptionEqualToValue}
                    id="combo-box-demo"
                    size="small"
                    options={hostsElement || []}
                    sx={{ width: { xs: "100%", sm: 250 } }}
                    value={
                      hostByElement
                        ? hostsElement.find((h) => h.hostid === hostByElement)
                        : Array.isArray(hostsElement) && hostsElement.length > 0
                          ? hostsElement[0]
                          : null
                    }
                    ListboxComponent={VirtualizedListbox}
                    renderOption={(props, option, { selected }) => (
                      <li
                        {...props}
                        style={{ padding: "0px" }}
                        key={option.itemid}
                      >
                        <Tooltip title={option.host} placement="left-start">
                          <Stack sx={styles.stackOption}>
                            <Checkbox checked={selected} />
                            <span style={styles.textoLimitado}>
                              {option.host}
                            </span>
                          </Stack>{" "}
                        </Tooltip>
                      </li>
                    )}
                    onChange={(event, newValue) => {
                      if (newValue) {
                        setHostByElement(newValue?.hostid);
                      } else {
                        setHostByElement(hostsElement[0]?.hostid);
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        placeholder="Host"
                        color="primary"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor:
                              theme.palette.background.paperLinkedMaps,
                            width: 250,
                          },
                        }}
                        slotProps={{
                          input: {
                            ...params.InputProps,
                            startAdornment: (
                              <Box>
                                <InputAdornment position="start">
                                  <IconTransform
                                    img={
                                      iconsElements.find(
                                        (icon) => icon.nome == "_roteador",
                                      )?.img
                                    }
                                    size="20px"
                                    color={theme.palette.color.bgIcon}
                                  />
                                </InputAdornment>
                              </Box>
                            ),
                          },
                        }}
                      />
                    )}
                  />
                )}
              <DateFilter
                ref={dateFilterRef}
                key={"modal"}
                filtersState={filtersState}
                setFilterState={setFilterState}
              />

              <Stack
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: 1,
                }}
              >
                <IconButton
                  id="icon-button-1"
                  sx={{
                    height: "40px",
                    backgroundColor: alpha(
                      theme.palette.background.cardStatus,
                      1,
                    ),
                    color: theme.palette.text.primary,
                    paddingX: 3,
                    fontWeight: "bold",
                    borderRadius: 1,
                    maxWidth: "50px",
                  }}
                  onClick={() => {
                    setHostByElement(hostsElement[0]?.hostid);
                    dateFilterRef.current.handleReset();
                  }}
                >
                  <Tooltip title="Limpar">
                    <Close />
                  </Tooltip>
                </IconButton>
                <IconButton
                  id="icon-button-2"
                  sx={{
                    height: "40px",
                    backgroundColor: alpha(
                      theme.palette.background.cardStatus,
                      1,
                    ),
                    color: theme.palette.text.primary,
                    paddingX: 3,
                    fontWeight: "bold",
                    borderRadius: 1,
                    maxWidth: "50px",
                  }}
                  onClick={() => {
                    setIsRefresh(true);
                  }}
                >
                  <Tooltip title="Recarregar">
                    <Refresh />
                  </Tooltip>
                </IconButton>
              </Stack>
              {/* <Button
                variant="text"
                onClick={() => {
                  setHostByElement(hostsElement[0]?.hostid);
                  dateFilterRef.current.handleReset();
                }}
                startIcon={<Close />}
              >
                Limpar
              </Button> */}
            </Stack>
          </Stack>
          {initialLoading ? (
            Array.from({ length: 6 }).map((_, index) => (
              <Skeleton
                key={index}
                variant="rectangular"
                sx={styles.skeleton}
              />
            ))
          ) : (
            <Grid2
              container
              columnSpacing={1.5}
              rowSpacing={1.5}
              width={"100%"}
              height={"100%"}
            >
              {Object.values(filteredData).map((f) => f)?.length > 0
                ? Object.values(filteredData).map((group, idx) => (
                    <Grid2
                      item
                      size={{ xs: 12, sm: 6, md: 6 }}
                      key={group.itemName}
                    >
                      {group.itemName?.includes("$1") ? (
                        <Box sx={styles.boxInvalidItem}>
                          <Typography variant="subtitle2" textAlign={"center"}>
                            {group.itemName}
                          </Typography>
                          <Stack
                            sx={{
                              alignItems: "center",
                              justifyContent: "center",
                              width: "100%",
                              gap: 1,
                            }}
                          >
                            <Stack
                              sx={{
                                p: 1.5,
                                bgcolor: alpha(theme.palette.warning.main, 0.1),
                                borderRadius: "100%",
                              }}
                            >
                              <WarningAmberRounded
                                sx={{ color: "warning.main", fontSize: 40 }}
                              />
                            </Stack>

                            <Typography
                              textAlign={"center"}
                              color="text.secondary"
                              fontSize={14}
                            >
                              O nome do item está incorreto.
                              <br />
                              Por favor, entre em contato com o suporte.
                            </Typography>
                          </Stack>
                        </Box>
                      ) : (
                        <Box sx={styles.boxRowFields}>
                          <LineChart
                            groupData={group.allData}
                            itemName={group.itemName}
                            unit={group.unit}
                            isMultiple={group.isMultiple}
                            method={group.method}
                            setFilterState={setFilterState}
                            enlaceSelected={enlaceSelected}
                            isPotencia={isPotencia}
                            colorOffset={idx}
                            filterState={filtersState}
                            loading={loading}
                          />
                        </Box>
                      )}
                    </Grid2>
                  ))
                : valueTab == 2 && (
                    <Box
                      sx={{
                        ...styles.boxNoRowsOverlay,
                        width: "100%",
                        height: "100%",
                        minHeight: 300,
                        borderRadius: 2,
                      }}
                    >
                      <EmptyBox style={styles.iconUserNotFound} />
                      <Typography color="text.disabled">
                        Nenhum dado encontrado
                      </Typography>
                    </Box>
                  )}
              {valueTab === 1 && (
                <Grid2 item size={12}>
                  <DataGrid
                    sx={styles.dataGrid}
                    rows={alerts}
                    columns={columns}
                    loading={loading}
                    disableColumnMenu={true}
                    pageSizeOptions={[10, 25, 50, 100]}
                    onPaginationModelChange={(model) =>
                      setPageSize(model.pageSize)
                    }
                    localeText={
                      ptBR.components.MuiDataGrid.defaultProps.localeText
                    }
                    getRowClassName={(params) => {
                      const isEven =
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "even-row"
                          : "odd-row";

                      const isPending =
                        params.row.recoveryDate === null ? "blink-row" : "";

                      return `${isEven} ${isPending}`;
                    }}
                    slots={{
                      noRowsOverlay: CustomNoRowsOverlay,
                    }}
                    initialState={{
                      pagination: {
                        paginationModel: { pageSize: pageSize },
                      },
                    }}
                    disableRowSelectionOnClick
                  />
                </Grid2>
              )}
            </Grid2>
          )}
        </DialogContent>
      </Paper>
    </Modal>
  );
}
